import React from 'react';
import { FileText, AlertCircle, CheckCircle2, XCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Card, CardContent } from './ui/card';

export const Regolamento = () => {
  const rules = [
    {
      title: 'Requisiti di adesione',
      content: (
        <div className="space-y-3">
          <div className="flex items-start">
            <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">La tessera VeCo è <strong>gratuita</strong> e ti apre le porte del circuito VeCo Shop.</p>
          </div>
          <div className="flex items-start">
            <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">La tessera è <strong>personale e non cedibile</strong> a terzi.</p>
          </div>
          <div className="flex items-start">
            <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">Il rilascio della tessera avviene <strong>solo presso i VeCo Point</strong> o esercizi convenzionati.</p>
          </div>
        </div>
      )
    },
    {
      title: 'Utilizzo della tessera',
      content: (
        <div className="space-y-3">
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-orange-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">La tessera deve essere <span className="font-semibold">presentata PRIMA del pagamento</span> e dichiarata all'attività convenzionata.</p>
          </div>
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-orange-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">Lo sconto <span className="font-semibold">non è retroattivo</span>: se presentata dopo il pagamento, lo sconto non verrà applicato.</p>
          </div>
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-orange-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">Ogni attività convenzionata applica sconti e condizioni specifiche. Verificare sempre i dettagli dell'offerta.</p>
          </div>
        </div>
      )
    },
    {
      title: 'Validità e rinnovo',
      content: (
        <div className="space-y-3">
          <div className="flex items-start">
            <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">La visibilità delle attività all'interno del circuito VeCo è garantita per tutta la durata del contratto.</p>
          </div>
          <div className="flex items-start">
            <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">In caso di scadenza o disdetta, la visibilità decade automaticamente.</p>
          </div>
        </div>
      )
    },
    {
      title: 'Attività convenzionate',
      content: (
        <div className="space-y-3">
          <div className="flex items-start">
            <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">Tutte le attività convenzionate espongono l'<span className="font-semibold">adesivo ufficiale "Attività Convenzionata VeCo Shop"</span>.</p>
          </div>
          <div className="flex items-start">
            <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">L'adesione di nuove attività al circuito avviene <strong>esclusivamente online o presso i VeCo Point</strong>.</p>
          </div>
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-orange-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">ReBon S.r.l. non è responsabile di eventuali disservizi o controversie tra tesserati e attività partner.</p>
          </div>
        </div>
      )
    },
    {
      title: 'Limitazioni e esclusioni',
      content: (
        <div className="space-y-3">
          <div className="flex items-start">
            <XCircle className="w-5 h-5 text-red-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">Gli sconti <span className="font-semibold">non sono cumulabili</span> con altre promozioni salvo diversa indicazione dell'attività.</p>
          </div>
          <div className="flex items-start">
            <XCircle className="w-5 h-5 text-red-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">Gli sconti applicati dalle attività partner <strong>non prevedono acquisti minimi</strong>, salvo diversa indicazione nella scheda dell'attività.</p>
          </div>
          <div className="flex items-start">
            <XCircle className="w-5 h-5 text-red-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">Le condizioni e le percentuali di sconto sono stabilite dalle attività partner e <strong>non possono essere modificate</strong>. Si consiglia di verificare sempre la validità dello sconto prima dell'acquisto.</p>
          </div>
        </div>
      )
    },
    {
      title: 'Norme di comportamento',
      content: (
        <div className="space-y-3">
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-orange-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">I tesserati si impegnano a comportarsi in modo <span className="font-semibold">corretto e rispettoso</span> presso le attività convenzionate.</p>
          </div>
          <div className="flex items-start">
            <XCircle className="w-5 h-5 text-red-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">L'<span className="font-semibold">uso fraudolento</span> della tessera (cessione, falsificazione, utilizzo senza contratto attivo) comporta l'<span className="font-semibold">esclusione permanente</span> dal circuito VeCo Shop, salvo richiesta di maggior danno.</p>
          </div>
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-orange-600 mr-3 mt-0.5 flex-shrink-0" />
            <p className="text-gray-700">ReBon S.r.l. si riserva il diritto di <span className="font-semibold">revocare la tessera</span> in caso di violazione del regolamento.</p>
          </div>
        </div>
      )
    }
  ];

  return (
    <section id="regolamento" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-6">
              <FileText className="w-8 h-8 text-purple-600" />
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Regolamento ufficiale
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Norme e condizioni per l'utilizzo della Tessera VeCo Shop Community
            </p>
          </div>

          {/* Accordion */}
          <Card className="border-2 border-gray-100">
            <CardContent className="p-6">
              <Accordion type="single" collapsible className="w-full">
                {rules.map((rule, index) => (
                  <AccordionItem key={index} value={`item-${index}`}>
                    <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-teal-600">
                      {rule.title}
                    </AccordionTrigger>
                    <AccordionContent className="pt-4">
                      {rule.content}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </CardContent>
          </Card>

          {/* Tessere VeCo - Immagini */}
          <div className="mt-12">
            <Card className="border-2 border-teal-200 overflow-hidden">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Le tessere VeCo ufficiali
                </h3>
                <p className="text-gray-700 text-center mb-8">
                  Queste sono le tessere VeCo attualmente attive e valide per ottenere gli sconti presso le attività convenzionate:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
                    <img
                      src="https://customer-assets.emergentagent.com/job_member-discounts/artifacts/trdmdme6_WhatsApp%20Image%202025-10-20%20at%2011.38.19%20%284%29.jpeg"
                      alt="Tessera VeCo - Keep Calm"
                      className="w-full h-auto"
                    />
                  </div>
                  <div className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
                    <img
                      src="https://customer-assets.emergentagent.com/job_member-discounts/artifacts/2s4145nn_WhatsApp%20Image%202025-10-20%20at%2011.38.19%20%283%29.jpeg"
                      alt="Tessera VeCo - High Five"
                      className="w-full h-auto"
                    />
                  </div>
                  <div className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
                    <img
                      src="https://customer-assets.emergentagent.com/job_member-discounts/artifacts/esbzudec_WhatsApp%20Image%202025-10-20%20at%2011.38.19%20%282%29.jpeg"
                      alt="Tessera VeCo - Business"
                      className="w-full h-auto"
                    />
                  </div>
                </div>
                <div className="mt-6 bg-teal-50 border border-teal-200 rounded-lg p-4">
                  <p className="text-sm text-gray-700 text-center">
                    <span className="font-semibold text-teal-700">Importante:</span> Solo queste tessere sono valide. 
                    Verificare sempre che la tessera presentata corrisponda a uno di questi modelli ufficiali.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Footer Note */}
          <div className="mt-12 text-center">
            <p className="text-sm text-gray-500">
              ReBon srl si riserva il diritto di modificare il regolamento in qualsiasi momento.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};